import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import fetchData from "../../api/fetchApi";
import PageHeader from "../common/PageHeader";

export default function InitiatePaymentPage() {
  const [formData, setFormData] = useState({
    account_id: "",
    payment_method_id: "",
    amount: "",
    identity_card: "",
  });
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingMethods, setLoadingMethods] = useState(false);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(null);
  const navigate = useNavigate();

  const [showConfirmForm, setShowConfirmForm] = useState(false);
  const [paymentId, setPaymentId] = useState(null);
  const [otp, setOtp] = useState("");
  const [confirmResponse, setConfirmResponse] = useState(null);
  const [confirmError, setConfirmError] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);

  useEffect(() => {
    const fetchPaymentMethods = async () => {
      setLoadingMethods(true);
      try {
        const data = await fetchData("finance/payment-methods");
        setPaymentMethods(data.data || []);
        if (data.data && data.data.length > 0) {
            setFormData(prev => ({...prev, payment_method_id: data.data[0].id}));
        }
      } catch (err) {
        setError("Failed to fetch payment methods.");
      } finally {
        setLoadingMethods(false);
      }
    };
    fetchPaymentMethods();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResponse(null);
    setConfirmError(null);
    setConfirmResponse(null);

    try {
      const result = await fetchData("finance/payments/initiate",
        'POST',
         JSON.stringify(formData),
      );
      setResponse(result);
      if (result.data && result.data.id) {
        setPaymentId(result.data.id);
        setShowConfirmForm(true);
      } else {
        setError("Payment ID not found in the response from initiation.");
      }
    } catch (err) {
      setError(err.message || "An error occurred while initiating the payment.");
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmSubmit = async (e) => {
    e.preventDefault();
    setConfirmLoading(true);
    setConfirmError(null);
    setConfirmResponse(null);

    try {
      const result = await fetchData("finance/payments/confirm",  "POST",
        JSON.stringify({ otp, payment_id: paymentId }),
      );
      setConfirmResponse(result);
    } catch (err) {
      setConfirmError(err.message || "An error occurred during payment confirmation.");
    } finally {
      setConfirmLoading(false);
    }
  };

  return (
    <div className="min-h-screen p-4 md:p-6 bg-white" dir="rtl">
      <PageHeader title="بدء عملية دفع جديدة" />
      <div className="bg-white p-6 rounded-lg ">
        {!showConfirmForm ? (
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="account_id" className="block text-sm font-medium text-gray-700 mb-1">
                معرف الحساب (Account ID)
              </label>
              <input
                type="number"
                name="account_id"
                id="account_id"
                value={formData.account_id}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
            <div className="mb-4">
              <label htmlFor="payment_method_id" className="block text-sm font-medium text-gray-700 mb-1">
                طريقة الدفع
              </label>
              <select
                name="payment_method_id"
                id="payment_method_id"
                value={formData.payment_method_id}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                required
                disabled={loadingMethods}
              >
                {loadingMethods ? (
                  <option>جاري تحميل طرق الدفع...</option>
                ) : (
                  paymentMethods.map((method) => (
                    <option key={method.id} value={method.id}>
                      {method.name}
                    </option>
                  ))
                )}
              </select>
            </div>
            <div className="mb-4">
              <label htmlFor="amount" className="block text-sm font-medium text-gray-700 mb-1">
                المبلغ
              </label>
              <input
                type="number"
                name="amount"
                id="amount"
                value={formData.amount}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
            <div className="mb-4">
              <label htmlFor="identity_card" className="block text-sm font-medium text-gray-700 mb-1">
                رقم الهاتف أو الهوية
              </label>
              <input
                type="text"
                name="identity_card"
                id="identity_card"
                value={formData.identity_card}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                required
              />
            </div>
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              disabled={loading}
            >
              {loading ? "جاري الإرسال..." : "بدء الدفع"}
            </button>
          </form>
        ) : (
          <div>
            <h2 className="text-xl font-bold mb-4">تأكيد الدفع</h2>
            {response && (
                <div className="mb-4">
                    <p className="text-sm text-gray-600">{response.message || "Please enter the OTP sent to your device."}</p>
                </div>
            )}
            <form onSubmit={handleConfirmSubmit}>
              <div className="mb-4">
                <label htmlFor="otp" className="block text-sm font-medium text-gray-700 mb-1">
                  رمز التحقق (OTP)
                </label>
                <input
                  type="text"
                  name="otp"
                  id="otp"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  required
                />
              </div>
              <button
                type="submit"
                className="w-full bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                disabled={confirmLoading}
              >
                {confirmLoading ? "جاري التأكيد..." : "تأكيد الدفع"}
              </button>
            </form>
          </div>
        )}

        {error && <div className="text-red-600 text-center mt-4">{error}</div>}
        {response && !showConfirmForm && (
          <div className="mt-4">
            <h3 className="text-lg font-bold">تم الاستلام بنجاح:</h3>
            <pre className="bg-gray-100 p-4 rounded-md text-sm overflow-x-auto">
              {JSON.stringify(response, null, 2)}
            </pre>
          </div>
        )}

        {confirmError && <div className="text-red-600 text-center mt-4">{confirmError}</div>}
        {confirmResponse && (
          <div className="mt-4">
            <h3 className="text-lg font-bold">نتيجة التأكيد:</h3>
            <pre className="bg-gray-100 p-4 rounded-md text-sm overflow-x-auto">
              {JSON.stringify(confirmResponse, null, 2)}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
}
